import styled from 'styled-components'

import { theme } from '@/styles/theme'
import { formatDate } from '@/utils/date'

import { Container } from './Container'
import { ExternalLinkIcon } from '@/components/elements/Icon/ExternalLink'
import { NewsTag } from '@/components/elements/News/NewsTag'

import type { Exposure } from '@/types/exposure'

export const MediaItem = ({
  name,
  mediaType,
  company,
  publishDate,
  content,
  url,
}: Exposure) => {
  return (
    <Article>
      <Container url={url}>
        <HeadSection>
          <Time dateTime={publishDate}>
            {formatDate(publishDate, 'yyyy/MM/dd')}
          </Time>
          <TagList>
            <NewsTag name={mediaType.type} code={mediaType.code} />
          </TagList>
          <MediaInfo>
            {name}／{company}
          </MediaInfo>
        </HeadSection>
        <Title>
          {content}
          {url && <ExternalLinkIcon size="small" />}
        </Title>
      </Container>
    </Article>
  )
}

const Article = styled.article`
  padding-bottom: 30px;
  :not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.backgroundBlue};
  }

  @media screen and (max-width: 1047px) {
    padding-bottom: 26px;
  }
`

const HeadSection = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 20px;
`

const Time = styled.time`
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 0.64px;
  color: ${theme.colors.textTitle};
`

const MediaInfo = styled.div`
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.64px;
  color: ${theme.colors.textTitle};
`

const TagList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

const Title = styled.h3`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.72px;
  line-height: 26px;
  color: ${theme.colors.textTitle};

  > svg {
    margin-left: 8px;
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 1.5px;
  }
`
